import { useState } from "react";
import { HelpCircle } from "lucide-react";
import { PortalTicketCreateFlow } from "./PortalTicketCreateFlow";
import "./styles.css";

interface DarkThemeWidgetProps {
  onClose?: () => void;
}

export default function DarkThemeWidget({ onClose }: DarkThemeWidgetProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
    onClose?.();
  };

  return (
    <>
      {!open && (
          <button
          onClick={() => setOpen(true)}
          className="sd-fab"
          style={{ right: "24px", left: "auto" }}
          aria-label="Open support"
          title="Open support"
        >
            <HelpCircle className="sd-fab-icon" size={22} strokeWidth={1.6} />
          <span className="sd-fab-pulse"></span>
        </button>
      )}

      {open ? <PortalTicketCreateFlow onClose={handleClose} /> : null}
    </>
  );
}

export { PortalTicketCreateFlow } from "./PortalTicketCreateFlow";
